import React from "react";
import PropTypes from "prop-types";
import DeleteIcon from "@material-ui/icons/Delete";
import A_SimpleDialog from "../../../Atoms/Feedback/Dialogs/A_SimpleDialog.jsx";
import A_Button from "../../../Atoms/Inputs/Buttons/A_Button.jsx";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1.5),
  },
  dangerButtonSolid: {
    backgroundColor: "var(--status-error-color) !important",
    color: "var(--color-primary-contrast) !important",
    borderColor: "var(--status-error-color) !important",
    "&:hover": {
      backgroundColor: "var(--status-error-color) !important",
      filter: "brightness(1.1)",
    },
  },
}));

const ConfirmDialog = ({
  open,
  mode,
  title,
  message,
  confirmLabel,
  onConfirm,
  onClose,
}) => {
  const classes = useStyles();
  const isInfo = mode === "info";
  return (
    <A_SimpleDialog
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="xs"
      dialogContent={message}
      dialogActions={
        isInfo ? (
          <A_Button label="OK" premiumVariant="primary" onClick={onClose} />
        ) : (
          <div className={classes.actions}>
            <A_Button
              label="Cancel"
              premiumVariant="secondary"
              onClick={onClose}
            />
            <A_Button
              label={confirmLabel}
              premiumVariant="primary"
              className={classes.dangerButtonSolid}
              startIcon={<DeleteIcon fontSize="small" />}
              onClick={onConfirm}
            />
          </div>
        )
      }
    />
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  mode: PropTypes.oneOf(["confirm", "info"]),
  title: PropTypes.string,
  message: PropTypes.node,
  confirmLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

ConfirmDialog.defaultProps = {
  open: false,
  mode: "confirm",
  title: "",
  confirmLabel: "Delete",
};

export default ConfirmDialog;
